import React, { Children } from 'react'
import { Ghost, LayoutBand } from '@fs/zion-ui'
import RainbowDivider from '../../../lib/RainbowDivider'
import ResponsiveSectionBand from '../../../lib/ResponsiveSectionBand'
import WhatIsRootsTechBanner from './WhatIsRootsTechBanner'
import LibraryHeading from './LibraryHeading'
import SponsorsCard from './SponsorsCard'
import MoreToExplore from './MoreToExplore'
import HorizontalCardGrid from './HorizontalCardGrid'
import { PillButton } from '../../../lib/buttons'

const flavors = ['blueberry', 'fire', 'apple', 'seafoam']

export default function OnDemandLibrarySections({ page, noHeading }) {
  // eslint-disable-next-line no-underscore-dangle
  const content = page?.content?.filter((item) => item.__typename !== 'VideoModule')

  return page ? (
    <>
      {!noHeading && (
        <>
          <RainbowDivider thick and full />
          <LayoutBand>
            <LibraryHeading />
          </LayoutBand>
        </>
      )}
      {Children.toArray(
        content?.map((section, ind) => {
          const { title, items, description, ctaUrl, ctaLabel } = section
          const flavor = flavors?.[ind % flavors.length]
          const actions = ctaUrl ? (
            <PillButton
              to={ctaUrl}
              data-testid="cta-button"
              linkName={`Section: ${title}: ${ctaLabel}`}
              emphasis="medium"
            >
              {ctaLabel}
            </PillButton>
          ) : null
          return (
            <Ghost heightEstimate={600} keepVisible>
              <ResponsiveSectionBand maxWidth="xl">
                <HorizontalCardGrid
                  items={items}
                  heading={title}
                  sectionDescription={description}
                  flavor={flavor}
                  actions={actions}
                />
              </ResponsiveSectionBand>
            </Ghost>
          )
        })
      )}
      <MoreToExplore />
      <ResponsiveSectionBand>
        <Ghost keepVisible heightEstimate={200}>
          <WhatIsRootsTechBanner />
        </Ghost>
      </ResponsiveSectionBand>
      <ResponsiveSectionBand>
        <Ghost keepVisible heightEstimate={680}>
          <SponsorsCard />
        </Ghost>
      </ResponsiveSectionBand>
    </>
  ) : null
}
